import script from "./wizard-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./wizard-page.vue?vue&type=script&setup=true&lang=ts"

import "./wizard-page.vue?vue&type=style&index=0&id=ab44d70a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.28_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab44d70a"]])

export default __exports__